import { Popover, Typography } from '@execonline-inc/execonline-ui';
import { noop } from '@kofno/piper';
import { Maybe } from 'maybeasy';
import { observer } from 'mobx-react';
import { ChangeEvent } from 'react';
import { T } from '../../../Translations';

interface Props {
  name: Maybe<string>;
  onChange: (value: string) => void;
  mode: 'builderV2' | 'Preview';
}

function Title({ name, onChange, mode }: Props) {
  const handleOnChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    switch (mode) {
      case 'Preview':
        return noop();
      case 'builderV2':
        return onChange(e.target.value);
    }
  };

  return name
    .map((name) => (
      <Popover
        trigger="hover"
        className="max-w-[21.625rem] !bg-gray-700"
        renderTrigger={(ref, getReferenceProps) => {
          const { 'aria-expanded': _, 'aria-haspopup': __, ...textareaProps } = getReferenceProps();
          return (
            <textarea
              ref={ref}
              {...textareaProps}
              className="border-none bg-transparent p-0 text-3xl focus:ring-0 w-full resize-none lg:h-[73px] xxl:h-9"
              value={name}
              rows={1}
              onChange={handleOnChange}
              aria-label="Collection title"
            />
          );
        }}
        children={
          <Typography variant="bodyMedium" color="white">
            <T kind="Your collection title is displayed here - EXO can generate the title and you can also change or remove the title by editing the collection later" />
          </Typography>
        }
      />
    ))
    .getOrElse(() => (
      <Typography variant="h4" className="opacity-30">
        <T kind="Your collection title will appear here" />
      </Typography>
    ));
}

export default observer(Title);
